import { useState } from 'react';
import get from 'lodash.get';
import { useTranslation } from 'react-i18next';
import { CancerHistoryNode } from '@myriadgenetics/mgh-types';
import ConfirmationModal from '../../../elements/confirmation-modal';
import { mapHistory } from './helper';

import './index.scss';
import Button from '../../../elements/button';
import { useUrl, isSimonMedUrl } from '../../../helpers/url';
import CancerHistoryCards from '../cancer-history-cards';
import { useButtonsWrapperContext } from '../../buttons-wrapper';
import { BackButton } from '../../buttons/back';
import { createPortal } from 'react-dom';

interface Props {
  baseKey: string;
  baseUrl?: string;
  responses: any;
  onResponseUpdated: (answerKey: string, val: any) => void;
  cancerHistoryNode?: CancerHistoryNode | null;
  onContinue: () => void;
  containerClass?: string;
}
interface DeleteConfirmation {
  translatedMessage: string;
  onConfirmation: () => void;
}

function CancerHistoryReview({ baseKey, baseUrl, responses, onResponseUpdated, containerClass, onContinue }: Props) {
  const { t } = useTranslation();
  const { urlType } = useUrl();
  const { buttonsRef, childRef } = useButtonsWrapperContext();
  const baseObj = get(responses, baseKey);
  const allRelativesPathologies = mapHistory(baseObj);

  const [confirmDelete, setConfirmDelete] = useState<DeleteConfirmation | null | undefined>();

  return (
    <div className="cancer-history-review" ref={childRef}>
      {confirmDelete && (
        <ConfirmationModal
          translatedMessage={confirmDelete.translatedMessage}
          confirmKey="Delete"
          containerClass={containerClass}
          onCancel={() => setConfirmDelete(undefined)}
          onConfirm={() => {
            confirmDelete.onConfirmation();
            setConfirmDelete(undefined);
          }}
        />
      )}
      <div className="cancer-history-review__content">
        <CancerHistoryCards
          allRelativesPathologies={allRelativesPathologies}
          responses={responses}
          baseKey={baseKey}
          baseUrl={baseUrl}
          onResponseUpdated={onResponseUpdated}
          setConfirmDelete={setConfirmDelete}
        />
        {!(urlType === 'cb' || urlType === 'smi') && buttonsRef?.current ? (
          createPortal(
            <>
              <BackButton />
              <Button className="cancer-history-review__continue-button" dataTestId="continue-button" onClick={onContinue}>
                {t('saveAndContinue')}
              </Button>
              <BackButton />
            </>,
            buttonsRef.current,
          )
        ) : (
          <>
            <Button
              className={isSimonMedUrl() ? 'smi__continue-button' : 'cancer-history-review__continue-button'}
              dataTestId="continue-button"
              onClick={onContinue}
            >
              {t('saveAndContinue')}
            </Button>
            <BackButton className={isSimonMedUrl() ? 'back-button__smi' : ''} />
          </>
        )}
      </div>
    </div>
  );
}

export default CancerHistoryReview;
